import Link from 'next/link'
import { useContext } from 'react'
import { Alert, Button, OverlayTrigger, Tooltip } from 'react-bootstrap'
import { CartsContext } from '@context/cart.ctx'

export default function TrackfyWarning() {
  const { trackfyPendencies, hasTrackfyPendencies, sendAppLinkToMotoboy } =
    useContext(CartsContext)

  if (!hasTrackfyPendencies) {
    return null
  }

  const missingCredentials = trackfyPendencies.filter((item) => item.missingCredentials)
  const appNotInstalled = trackfyPendencies.filter((item) => item.appNotInstalled)

  const credentialsTooltip = (
    <Tooltip id="trackfy-credentials-tooltip">
      <ul className="ps-3 mb-0 text-start">
        {missingCredentials.map((item) => (
          <li key={`credentials-${item.motoboyId}`}>{item.motoboyName}</li>
        ))}
      </ul>
    </Tooltip>
  )

  const appTooltip = (
    <Tooltip id="trackfy-app-tooltip">
      <ul className="ps-3 mb-0 text-start">
        {appNotInstalled.map((item) => (
          <li key={`app-${item.motoboyId}`}>{item.motoboyName}</li>
        ))}
      </ul>
    </Tooltip>
  )

  return (
    <Alert variant="warning" dismissible style={{ transition: 'all 0.5s' }}>
      <Alert.Heading>Pendências TrackFy</Alert.Heading>
      Existem entregadores com informações necessárias faltando para o uso do TrackFy.
      {missingCredentials.length ? (
        <div className="mt-2">
          Cadastro incompleto (e-mail e senha):{' '}
          <OverlayTrigger overlay={credentialsTooltip}>
            <a href="#">{missingCredentials.length} entregador(es)</a>
          </OverlayTrigger>
          . Clique <Link href="/dashboard/motoboys">aqui</Link> para cadastrar.
        </div>
      ) : null}
      {appNotInstalled.length ? (
        <div className="mt-2">
          Aplicativo não instalado:{' '}
          <OverlayTrigger overlay={appTooltip}>
            <a href="#">{appNotInstalled.length} entregador(es)</a>
          </OverlayTrigger>
          . Oriente o entregador a instalar e entrar no app.
          <div className="mt-2 row g-2">
            {appNotInstalled.map((item) => (
              <div
                key={`send-link-${item.motoboyId}`}
                className="col-12 col-sm-6 col-md-4"
              >
                <Button
                  size="sm"
                  variant="outline-dark"
                  className="w-100"
                  onClick={() =>
                    sendAppLinkToMotoboy({
                      name: item.motoboyName,
                      whatsapp: item.whatsapp,
                    })
                  }
                >
                  Enviar link para {item.motoboyName}
                </Button>
              </div>
            ))}
          </div>
        </div>
      ) : null}
    </Alert>
  )
}
